// Manual - mean that state changed by user
export type PanelType = "pin" | "show" | "hide" | "pinManual" | "hideManual";

export function isPanelPinned(panelType: PanelType): boolean {
    return panelType === "pin" || panelType === "pinManual";
}

export function isPanelTypeChangeManually(panelType: PanelType): boolean {
    return panelType === "pinManual" || panelType === "hideManual";
}

export function isPanelHidden(panelType: PanelType): boolean {
    return panelType === "hide" || panelType === "hideManual";
}

export type PanelTabType = "menu" | "check";

export enum ActionPanelButtonWidth {
    smallSize = 85,
    middleSize1 = 115,
    middleSize2 = 190,
    middleSize3 = 200,
    largeSize = 210,
}
